// Types
import type { Action } from "./types";

/**
 * @desc fetch a company's pre-authorized debit banking details
 * @param {*} data business guid
 * @return {*}  {Action}
 */
export const fetchCompanyBank = (data: any): Action => ({
  type: "FETCH_COMPANY_BANK",
  data,
});

/**
 * @param {*} data
 * @return {*}  {Action}
 */
export const editCompanyBank = (data: any): Action => ({
  type: "EDIT_COMPANY_BANK",
  data,
});

/**
 * @desc save a company's pre-authorized debit banking details
 * @param {*} data
 * @return {*}  {Action}
 */
export const updateCompanyBank = (data: any): Action => ({
  type: "UPDATE_COMPANY_BANK",
  data,
});

/**
 * @return {*}  {Action}
 */
export const clearCompanyBank = (): Action => ({
  type: "CLEAR_COMPANY_BANK",
});

/**
 * @desc fetch whether a company has signed up for pre-authorized debit
 * @param {*} data business guid
 * @return {*}  {Action}
 */
export const fetchCompanyPad = (data: any): Action => ({
  type: "FETCH_COMPANY_PAD",
  data,
});

/**
 * @param {*} data
 * @return {*}  {Action}
 */
export const editCompanyPad = (data: any): Action => ({
  type: "EDIT_COMPANY_PAD",
  data,
});

/**
 * @desc turn a company's pre-authorized debit sign-up on or off
 * @param {*} data
 * @return {*}  {Action}
 */
export const updateCompanyPad = (data: any): Action => ({
  type: "UPDATE_COMPANY_PAD",
  data,
});
